import axiosInstance from "../../axios/axiosInstance";

export const getAllPermissionList = (props) => onResponse => {

    try {
        axiosInstance.get("/roles/list-permissions")
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};
export const createRole = (props) => onResponse => {

    try {
        axiosInstance.post("/roles/create-new-role", props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};
export const getAllRoles = (props) => onResponse => {
    let BASE_URL = '/roles/list-roles?'
    if (props?.page) {
        BASE_URL = BASE_URL + 'page=' + props.page + '&'
    }
    if (props?.pageSize) {
        BASE_URL = BASE_URL + 'pageSize=' + props.pageSize + '&'
    }
    if (props?.search) {
        BASE_URL = BASE_URL + 'search=' + props.search + '&'
    }
    try {
        axiosInstance.get(BASE_URL)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};
export const getSingleRoleDetails = (id) => onResponse => {
    try {
        axiosInstance.get('/roles/get-role-details?roleId=' + id)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};
export const updateRole = (props) => onResponse => {
    try {
        axiosInstance.post('/roles/edit-role-details', props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};
export const deleteRole = (id) => onResponse => {
    try {
        axiosInstance.post('/roles/remove-role', { roleId: id })
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};